import React, { useEffect, useState } from 'react';
import PageLoader from '../../../../component/PageLoader';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import SendEmail from '../../../components/SendEmail';
import { getOrgReceipientEmails, sendEmailReport } from '../../../../services/reports';
import { capitalizeWords } from '../../../../utils/constant';

export default function SendEmailReport() {
	const params = useParams();
	const { type } = params;
	const { userInfo } = useSelector((state) => state);
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();
	const location = useLocation();
	const [toEmails, setToEmails] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [orgEmails, setOrgEmails] = useState([]);
	const [emailFormData, setEmailFormData] = useState({
		report_name: '',
		from: '',
		to: [],
		subject: '',
		filters: '',
		body: '',
		file_format: 'pdf',
	});

	async function handleSend(formData) {
		try {
			const res = await sendEmailReport(formData);
			if (res.success) {
				toast.success('Email Sent Successfully.');
				const reportName = type.replaceAll('_', '-').toLowerCase();
				navigate(`/user/${suburl}/reports/${reportName}`);
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
			throw error;
		}
	}

	function handleClose() {
		const reportName = type.replaceAll('_', '-').toLowerCase();
		navigate(`/user/${suburl}/reports/${reportName}`);
	}

	async function handleFetchReportDetails() {
		try {
			setIsLoading(true);
			const { users } = await getOrgReceipientEmails();
			setOrgEmails(users);
		} catch (error) {
			toast.error('Something went wrong!');
		} finally {
			setIsLoading(false);
		}
	}

	const getFilterData = () => {
		if (location.state) {
			setEmailFormData((prev) => ({
				...prev,
				filters: location.state.filter,
			}));
		}
	};

	useEffect(() => {
		if (type) {
			handleFetchReportDetails();
		}
	}, [type]);

	useEffect(() => {
		getFilterData();
	}, [location]);

	useEffect(() => {
		if (orgEmails && userInfo) {
			let customerEmailList = orgEmails.map((item) => item.email);
			let customerToSendEmailList = orgEmails.map((item) => item.email);
			setEmailFormData((prev) => ({
				...prev,
				report_name: type,
				to: customerToSendEmailList,
				from: `${userInfo?.userInfo?.data?.first_name} ${userInfo?.userInfo?.data?.last_name}`,
				subject: `${capitalizeWords(type.replaceAll('_', ' '))} from ${userInfo?.userInfo?.data?.first_name + ' ' + userInfo?.userInfo?.data?.last_name}`,
			}));
			setToEmails(customerEmailList);
		}
	}, [orgEmails, userInfo]);

	if (isLoading) {
		return <PageLoader />;
	}
	return (
		<SendEmail
			pdfName={capitalizeWords(type.replaceAll('_', ' '))}
			pdfId={`${capitalizeWords(type.replaceAll('_', ' '))}`}
			toEmails={toEmails}
			formData={emailFormData}
			handleSend={handleSend}
			handleClose={handleClose}
			isDropdownListShow={true}
		/>
	);
}
